<template>
    <div class="popup confirm-popup visible" id="create-branch-check-list" @click.stop="">
        <div class="confirm-icon">
            <img :src="require('Assets/confirm-ok-icon.svg')" width="104" height="104" alt="" />
        </div>
        <p v-show="data.msg" v-html="data.msg"></p>
        <div class="btns-box">
            <a href class="btn" @click.stop.prevent="$emit('close')">Продолжить работу</a>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'complete-component',
        computed: {
            ...mapState({
                data: state => state.popupData
            })
        },
    }
</script>


<style scoped>

</style>
